import axios from 'axios'

class ProcessHub {
  _inited = false
  _userId = null
  _echoChannel = null

  processes = new Map()

  listeners = {
    start: new Set(),
    progress: new Set(),
    completed: new Set(),
    cancelled: new Set(),
    change: new Set(),
  }

  init(userId) {
    if (this._inited) return
    this._inited = true
    this._userId = userId

    this.seed()

    this._echoChannel = window.Echo
      .private(`user.${userId}`)
      .listen('.process.started', e => this._onStarted(e.process))
      .listen('.process.progress', e => this._onProgress(e.process))
      .listen('.process.completed', e => this._onCompleted(e.process))
      .listen('.process.cancelled', e => this._onCancelled(e.process))
  }

  destroy() {
    try { this._echoChannel && this._echoChannel.unsubscribe() } catch {}
    this._echoChannel = null
    this.listeners.start.clear()
    this.listeners.progress.clear()
    this.listeners.completed.clear()
    this.listeners.cancelled.clear()
    this.listeners.change.clear()
    this.processes.clear()
    this._inited = false
  }

  async seed() {
    try {
      const { data } = await axios.get('/api/admin/process/active')
      data.forEach(p => this.processes.set(p.process_key, p))
      this._emit('change', this.list())
    } catch (e) {
      console.warn('[ProcessHub] seed failed', e)
    }
  }

  on(event, handler) { this.listeners[event]?.add(handler); return () => this.off(event, handler) }
  off(event, handler) { this.listeners[event]?.delete(handler) }

  _emit(event, payload) {
    this.listeners[event]?.forEach(fn => { try { fn(payload) } catch {} })
  }

  list(filter = {}) {
    // filter: { type?, project_id? }
    const arr = Array.from(this.processes.values())
    if (!filter) return arr
    return arr.filter(p => {
      if (filter.type && p.type !== filter.type) return false
      if (filter.project_id && Number(p.project_id) !== Number(filter.project_id)) return false
      return true
    })
  }

  isInProgress({ type, project_id, process_key }) {
    if (process_key) return this.processes.has(process_key)
    const arr = this.list({ type, project_id })
    return arr.length > 0
  }

  _onStarted(p) {
    this.processes.set(p.process_key, p)
    this._emit('start', p)
    this._emit('change', this.list())
  }

  _onProgress(p) {
    const prev = this.processes.get(p.process_key)
    const merged = { ...(prev || {}), ...p }
    this.processes.set(p.process_key, merged)
    this._emit('progress', merged)
    this._emit('change', this.list())
  }

  _onCompleted(p) {
    const existed = this.processes.has(p.process_key)
    this.processes.delete(p.process_key)
    this._emit('completed', p)
    if (existed) this._emit('change', this.list())
  }

  _onCancelled(p) {
    const existed = this.processes.has(p.process_key)
    this.processes.delete(p.process_key)
    this._emit('cancelled', p)
    if (existed) this._emit('change', this.list())
  }
}

const hub = new ProcessHub()
export default hub
